const ComponentStyles= {
  textFamily: 'Rubik',
  titleFont: 28,
  subTitleFont: 16,
  titltWeight: '500'
}

export { ComponentStyles };